import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserTypeSelector } from './user-type-selector';
import { RegistrationForm } from './registration-form';
import type { UserType } from '@/lib/types/registration';

export function RegistrationFlow() {
  const navigate = useNavigate();
  const [step, setStep] = useState<'type-selection' | 'form' | 'success'>('type-selection');
  const [selectedType, setSelectedType] = useState<UserType | null>(null);

  const handleTypeSelect = (type: UserType) => {
    setSelectedType(type);
    setStep('form');
  };

  const handleBack = () => {
    setSelectedType(null);
    setStep('type-selection');
  };

  const handleSuccess = () => {
    setStep('success');
    setTimeout(() => {
      navigate('/dashboard');
    }, 1500);
  };

  return (
    <div className="container flex min-h-screen w-full flex-col items-center justify-start overflow-y-auto px-4 py-8 sm:py-12">
      <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[450px]">
        {step === 'type-selection' && (
          <UserTypeSelector onSelect={handleTypeSelect} />
        )}

        {step === 'form' && selectedType && (
          <RegistrationForm
            userType={selectedType}
            onBack={handleBack}
            onSuccess={handleSuccess}
          />
        )}

        {step === 'success' && (
          <div className="text-center space-y-4">
            <div className="inline-flex items-center justify-center p-3 rounded-full bg-primary/10">
              <svg
                className="h-12 w-12 text-primary animate-spin"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            </div>
            <h2 className="text-2xl font-semibold">Redirecting...</h2>
            <p className="text-muted-foreground">
              Your account has been created successfully.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
